<template lang="pug">
  div
    .row
      .col
        strong User Name:
        |  {{ username }}
    .row.mt-3
      .col-sm-12.col-lg-4
        .form-group
          label(for="first-name" required) First Name
          input#first-name(type="text"
            :value="firstName"
            @input="$emit('update:firstName', $event.target.value)"
            :class="{'is-invalid': firstNameInvalid}"
            autocomplete="fake-crap").form-control
          FormError(v-show="firstNameInvalid") First name is required.
      .col-sm-12.col-lg-4
        .form-group
          label(for="middle-name") Middle Name
          input#middle-name(type="text"
            :value="middleName"
            @input="$emit('update:middleName', $event.target.value)"
            autocomplete="fake-crap").form-control
      .col-sm-12.col-lg-4
        .form-group
          label(for="last-name" required) Last Name
          input#last-name(type="text"
            :value="lastName"
            @input="$emit('update:lastName', $event.target.value)"
            :class="{'is-invalid': lastNameInvalid}"
            autocomplete="fake-crap").form-control
          FormError(v-show="lastNameInvalid") Last name is required.
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="title") Title
          input#title(type="text"
            :value="title"
            @input="$emit('update:title', $event.target.value)").form-control
    .row(v-if="!editPrimaryEmail")
      .col
        p Please contact your administrator if your primary email address needs to be changed.
    .row(v-if="!editPrimaryEmail")
      .col
        strong Primary Email Address:
        |  {{ email }}
    .row.mt-3(v-if="editPrimaryEmail")
      .col-sm-12.col-lg-8
        .form-group
          label(for="email" required) Primary Email Address
          input#email.form-control(type="text"
            :value="email"
            @input="$emit('update:email', $event.target.value)"
            :class="{'is-invalid': emailInvalid}"
            autocomplete="fake-crap")
          FormError(v-show="emailInvalid") {{ emailError }}
    .row.mt-3
      .col-sm-12.col-lg-8
        .form-group
          label(for="alt-email-1") Additional Email Address
          input#alt-email-1.form-control(type="text"
            :value="altEmail1"
            @input="$emit('update:altEmail1', $event.target.value)"
            :class="{'is-invalid': altEmail1Invalid}"
            autocomplete="fake-crap")
          FormError(v-show="altEmail1Invalid") {{ emailError }}
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="alt-email-2") Additional Email Address
          input#alt-email-2.form-control(type="text"
            :value="altEmail2"
            @input="$emit('update:altEmail2', $event.target.value)"
            :class="{'is-invalid': altEmail2Invalid}"
            autocomplete="fake-crap")
          FormError(v-show="altEmail2Invalid") {{ emailError }}
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="work-phone") Work Phone
          input#work-phone.form-control(type="text"
            :value="workPhone"
            @input="$emit('update:workPhone', $event.target.value)"
            autocomplete="off"
            :class="{'is-invalid': phoneFormatInvalid}")
          FormError(v-show="phoneFormatInvalid") {{ phoneFormatError }}
    .row
      .col-sm-12.col-lg-4
        .form-group
          label(for="super-first-name" required) Supervisor's First Name
          input#super-first-name(type="text"
            :value="superFirstName"
            @input="$emit('update:superFirstName', $event.target.value)"
            :class="{'is-invalid': superFirstNameInvalid}"
            autocomplete="fake-crap").form-control
          FormError(v-show="superFirstNameInvalid") Supervisor's first name is required.
      .col-sm-12.col-lg-4
        .form-group
          label(for="super-middle-name") Supervisor's Middle Name
          input#super-middle-name(type="text"
            :value="superMiddleName"
            @input="$emit('update:superMiddleName', $event.target.value)"
            autocomplete="fake-crap").form-control
      .col-sm-12.col-lg-4
        .form-group
          label(for="super-last-name" required) Supervisor's Last Name
          input#super-last-name(type="text"
            :value="superLastName"
            @input="$emit('update:superLastName', $event.target.value)"
            :class="{'is-invalid': superLastNameInvalid}"
            autocomplete="fake-crap").form-control
          FormError(v-show="superLastNameInvalid") Supervisor's last name is required.
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="super-rank" required) Supervisor's Rank
          input#super-rank(type="text"
            :value="superRank"
            @input="$emit('update:superRank', $event.target.value)"
            :class="{'is-invalid': superRankInvalid}"
            autocomplete="fake-crap").form-control
          FormError(v-show="superRankInvalid") Supervisor's rank is required.
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="super-email" required) Supervisor's Email Address
          input#super-email.form-control(type="text"
            :value="superEmail"
            @input="$emit('update:superEmail', $event.target.value)"
            :class="{'is-invalid': superEmailInvalid || superEmailIfInvalid}"
            autocomplete="fake-crap")
          FormError(v-show="superEmailIfInvalid") {{ superEmailError }}
          FormError(v-show="superEmailInvalid", message="Supervisor's email is required.")
    .row
      .col-sm-12.col-lg-8
        .form-group
          label(for="super-phone" required) Supervisor's Phone
          input#super-phone.form-control(type="text"
            :value="superPhone"
            @input="$emit('update:superPhone', $event.target.value)"
            autocomplete="fake-crap"
            :class="{'is-invalid': superPhoneInvalid || superPhoneFormatInvalid}")
          FormError(v-show="superPhoneFormatInvalid") {{ phoneFormatError }}
          FormError(v-show="superPhoneInvalid", message="Supervisor's phone number is required.")
    .row(v-if="showNotes")
      .col
        .form-group
          label(for="notes") User Notes
          textarea#notes.form-control(type="text"
            :value="notes"
            @input="$emit('update:notes', $event.target.value)")
    .row
      .col
        button.btn.btn-primary.mr-3(@click.prevent="$emit('save')") Save Changes
        button.btn.btn-light(@click.prevent="$emit('cancel')") Cancel
</template>

<script>
import stdmsg from '@/lib/stdmsg'
export default {
  name: 'EditPersonalInfo',
  props: {
    userNotes: {
      type: Boolean,
      default: false,
    },
    editPrimaryEmail: {
      type: Boolean,
      default: false,
    },
    username: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    middleName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    altEmail1: {
      type: String,
      default: '',
    },
    altEmail2: {
      type: String,
      default: '',
    },
    workPhone: {
      type: String,
      default: '',
    },
    notes: {
      type: String,
      default: '',
    },
    superFirstName: {
      type: String,
      default: '',
    },
    superMiddleName: {
      type: String,
      default: '',
    },
    superLastName: {
      type: String,
      default: '',
    },
    superRank: {
      type: String,
      default: '',
    },
    superEmail: {
      type: String,
      default: '',
    },
    superPhone: {
      type: String,
      default: '',
    },
    firstNameInvalid: {
      type: Boolean,
      default: false,
    },
    lastNameInvalid: {
      type: Boolean,
      default: false,
    },
    emailInvalid: {
      type: Boolean,
      default: false,
    },
    altEmail1Invalid: {
      type: Boolean,
      default: false,
    },
    altEmail2Invalid: {
      type: Boolean,
      default: false,
    },
    phoneFormatInvalid: {
      type: Boolean,
      default: false,
    },
    superFirstNameInvalid: {
      type: Boolean,
      default: false,
    },
    superLastNameInvalid: {
      type: Boolean,
      default: false,
    },
    superRankInvalid: {
      type: Boolean,
      default: false,
    },
    superEmailInvalid: {
      type: Boolean,
      default: false,
    },
    superEmailIfInvalid: {
      type: Boolean,
      default: false,
    },
    superEmailError: {
      type: String,
      default: stdmsg.emailError,
    },
    superPhoneFormatInvalid: {
      type: Boolean,
      default: false,
    },
    superPhoneInvalid: {
      type: Boolean,
      default: false,
    },
    showNotes: {
      type: Boolean,
      default: true,
    },
    emailError: {
      type: String,
      default: stdmsg.emailError,
    },
  },
  data() {
    return {
      // emailError: stdmsg.emailError,
      phoneFormatError: stdmsg.phoneFormatError,
    }
  },
}
</script>

<style lang="scss" scoped>
#notes {
  height: 5rem;
}
</style>
